import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, staggerItem } from '../../utility/framerMotionAnimations';
import './EmiCalculator.css';

const EmiInfoSection = () => {
    return (
        <div className="emi-info-section">
            <div className="emi-info-container">
                <motion.div 
                    className="info-content"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                >
                    {/* Section 1: What Is an EMI Calculator? */}
                    <motion.div 
                        className="info-card"
                        variants={staggerItem}
                    >
                        <h2 className="section-heading">
                            What Is an EMI Calculator?
                        </h2>
                        <p className="section-text">
                            An EMI calculator helps you compute EMI for various loans such as home loans, car loans, personal loans, and education loans online for free. It computes EMI in seconds and shows a breakdown of principal and interest components. This tool aids in comparing loan options and planning your monthly budget effectively.
                        </p>
                    </motion.div>

                    {/* Section 2: How Does an EMI Calculator Work? */}
                    <motion.div 
                        className="info-card"
                        variants={staggerItem}
                    >
                        <h2 className="section-heading">
                            How Does an EMI Calculator Work?
                        </h2>
                        <p className="section-text">
                            Using an online EMI calculator is simple and straightforward. It considers three main factors: loan amount, interest rate, and loan duration. Once you enter these details, it displays the EMI along with a detailed breakdown of the principal amount, interest amount, and total payable.
                        </p>
                    </motion.div>

                    {/* Section 3: How To Use Our Loan EMI Calculator? */}
                    <motion.div 
                        className="info-card"
                        variants={staggerItem}
                    >
                        <h2 className="section-heading">
                            How To Use Our Loan EMI Calculator?
                        </h2>
                        <p className="section-text">
                            Using our EMI calculator is easy and effortless. Simply open it online and follow these simple steps:
                        </p>
                        <ul className="steps-list">
                            <li>Enter the loan amount</li>
                            <li>Enter the interest rate</li>
                            <li>Enter the duration of the loan</li>
                        </ul>
                        <p className="section-text">
                            The calculator provides quick results with a breakdown of total payable, interest, and principal.
                        </p>
                        
                        {/* Example Section */}
                        <div className="example-box">
                            <h4 className="example-heading">
                                Example:
                            </h4>
                            <p className="section-text">
                                Let's say you want a loan of ₹1,20,000 for wedding expenses with a 7% interest rate and 3-year duration.
                            </p>
                            <ul className="example-list">
                                <li><strong>EMI:</strong> ₹3,705/month</li>
                                <li><strong>Principal amount:</strong> ₹1,20,000</li>
                                <li><strong>Interest:</strong> ₹13,389</li>
                                <li><strong>Total Payable:</strong> ₹1,33,389</li>
                            </ul>
                        </div>
                    </motion.div>

                    {/* Section 4: Factors Affecting Your EMI Amount */}
                    <motion.div 
                        className="info-card"
                        variants={staggerItem}
                    >
                        <h2 className="section-heading">
                            Factors Affecting Your EMI Amount
                        </h2>
                        <div className="factors-list">
                            <div className="factor-item">
                                <h5 className="factor-title">
                                    Interest rate:
                                </h5>
                                <p className="factor-text">
                                    A higher interest rate increases your EMI as you pay more interest on the loan amount.
                                </p>
                            </div>
                            <div className="factor-item">
                                <h5 className="factor-title">
                                    Loan tenure:
                                </h5>
                                <p className="factor-text">
                                    Shorter tenures lead to higher EMIs, while longer tenures result in lower EMIs but higher total interest.
                                </p>
                            </div>
                            <div className="factor-item">
                                <h5 className="factor-title">
                                    Type of interest:
                                </h5>
                                <p className="factor-text">
                                    Fixed or floating interest rates affect your EMI. Floating rates may change during the loan tenure.
                                </p>
                            </div>
                            <div className="factor-item">
                                <h5 className="factor-title">
                                    Credit score:
                                </h5>
                                <p className="factor-text">
                                    A better credit score can lead to lower interest rates, thereby affecting your EMI amount.
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
};

export default EmiInfoSection;

